module.exports = __webpack_public_path__ + "static/media/award_light_blue.31f2c76f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/product-step/award_light_blue.png
// module id = 1637
// module chunks = 0